var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getFiltroDuracionMin < _vm.getFiltroDuracionMax)?_c('div',[(!_vm.isPreloader)?_c('filtro',{attrs:{"heading":"Noches","icono":"weather-night","total":false}},[_c('slider',{ref:"slider"})],1):_c('placeholder')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }